import type { EnumUnion } from '@dresscode-frontend/utility-types';
import type { StorageDriveType, StorageService as StorageServiceType } from './-query/drives-for-select/type';
export const StorageService = {
  BOX: 'BOX',
  GOOGLE_DRIVE: 'GOOGLE_DRIVE'
} as const satisfies Record<StorageServiceType, StorageServiceType>;
export type StorageService = EnumUnion<typeof StorageService>;
export const STORAGE_DRIVE_TYPE_VALUES = ['SHARED', 'PERSONAL'] as const satisfies readonly StorageDriveType[];